// Zeitzone: volle IANA-Liste über die Plattform (ECMA-402), keine eigene/gepflegte
// Liste — bei Zeitzonen sind Hardcodings fehleranfällig (DST, Umbenennungen). Kein
// zusätzliches Dependency, kein Nexus-Publish nötig. Fallback nur für sehr alte
// Engines ohne supportedValuesOf.
const TIMEZONE_FALLBACK = 'Europe/Berlin';

export function listTimezones(): string[] {
  const supported = (Intl as typeof Intl & { supportedValuesOf?: (key: string) => string[] }).supportedValuesOf;
  return typeof supported === 'function' ? supported('timeZone') : [TIMEZONE_FALLBACK];
}

export function detectBrowserTimezone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || TIMEZONE_FALLBACK;
}

/**
 * Die IANA-Liste plus Zonen, die darin fehlen: Aliasse wie „Asia/Calcutta“ oder „UTC“
 * meldet der Browser selbst als eigene Zone, oder sie stehen schon gespeichert. Ohne
 * eigenen Eintrag zeigte die Auswahl dafür nichts an.
 */
export function timezoneOptions(...extra: (string | null | undefined)[]): string[] {
  const zones = new Set(listTimezones());
  extra.filter((zone): zone is string => !!zone).forEach((zone) => zones.add(zone));
  return [...zones].sort();
}
